import { supabase } from '../supabaseClient';

export async function joinList({ email, phone, city }) {
  const payload = {
    email: email?.trim() || null,
    phone: phone?.trim() || null,
    city: city?.trim() || null,
  };
  const { error } = await supabase.from('subscribers').insert(payload);
  if (error) {
    if (error.code === '23505') throw new Error("You're already on the list!");
    throw error;
  }
}
